// Features/Download-Link/Component.ts
import { trackFileDownloaded } from "Analytics";
class DownloadLink extends HTMLElement {
  anchor;
  constructor() {
    super();
    const anchor = this.querySelector("a");
    if (!anchor)
      throw `Missing <a> tag in <download-link>`;
    this.anchor = anchor;
    const onDownload = this.onDownload.bind(this);
    anchor.addEventListener("click", onDownload);
  }
  onDownload() {
    trackFileDownloaded({
      file: this.details
    });
  }
  get details() {
    const { href } = this.anchor;
    const url = new URL(href);
    const path = url.pathname;
    const file = path.split("/").at(-1);
    const parts = file.split(".");
    const type = parts.pop();
    const name = parts.join(".");
    return { name, type };
  }
}

// Features/Download-Link/mod.ts
customElements.define("download-link", DownloadLink);
